<template>
  <div>
    <el-row>
      <el-col :span="6">
        <div style="padding-left: 30px; padding-top: 30px">
          <el-tree
            :expand-on-click-node="false"
            @node-click="nodeClick"
            :default-expand-all="true"
            :data="sysdeptData"
            node-key="id"
            :props="deptProps"
          >
          </el-tree>
        </div>
      </el-col>
      <el-col :span="18">
        <div style="padding-left: 30px; padding-top: 30px">
          <el-card class="box-card">
            <el-row :gutter="20" style="margin-left: 10px">
              <el-col :span="6">
                <el-input placeholder="姓名" v-model="qparam.realName" />
              </el-col>
              <el-col :span="6">
                <el-input placeholder=" 联系电话" v-model="qparam.phone" />
              </el-col>
              <el-col :span="12">
                <el-button
                  icon="el-icon-refresh-left"
                  type="primary"
                  @click="resetQparam"
                  >重置</el-button
                >

                <el-button
                  icon="el-icon-search"
                  type="primary"
                  @click="getAllSysUser"
                  >查询</el-button
                >
              </el-col>
            </el-row>
          </el-card>
          <el-table
            :data="userData"
            :header-cell-style="{
              background: 'rgb(245,245,245)',
              color: 'black',
            }"
            :cell-style="{ color: 'black' }"
          >
            <el-table-column label="身份信息">
              <template slot-scope="scope">
                姓名: <span> {{ scope.row.realName }}</span
                ><br />
                性别: <span v-if="scope.row.sex == 1"> 男</span>
                <span v-if="scope.row.sex == 2"> 女</span><br />
                年龄: <span> {{ scope.row.age }}</span>
              </template>
            </el-table-column>
            <el-table-column label="岗位信息">
              <template slot-scope="scope">
                职务: <span> {{ scope.row.post }}</span
                ><br />
                岗位: <span> {{ scope.row.jobPosition }}</span
                ><br />
                职称: <span> {{ scope.row.jobTitle }}</span
                ><br />
              </template>
            </el-table-column>
            <el-table-column label="单位信息">
              <template slot-scope="scope">
                所属市县: <span> {{ scope.row.workAddress }}</span
                ><br />
                单位名称: <span> {{ scope.row.workName }}</span
                ><br />
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              align="center"
              label="操作"
              width="120"
            >
              <template slot-scope="scope">
                <el-row v-if="selectedUser.indexOf(scope.row.userId) < 0">
                  <el-button
                    type="primary"
                    size="small"
                    @click="selectUser(scope.row.userId, scope.row)"
                    >选择</el-button
                  >
                </el-row>
                <el-row v-else>
                  <el-tag type="danger">已被配置</el-tag>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin: 40px auto; width: 30%">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="qparam.pageNum"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="qparam.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              :page-count="totlePages"
            >
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { requestGetAllSysUserTableList, requestGetSysDeptTree } from "../api";
export default {
  name: "SelectUser",
  props: {
    selectedUser: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      sysdeptData: [],
      deptProps: {
        children: "children",
        label: "text",
      },
      userData: [],
      qparam: {
        realName: "",
        phone: "",
        deptId: 0,
        pageNum: 1,
        pageSize: 5,
      },
      totlePages: null, //总页数
      total: null, //总记录结果行数
    };
  },
  methods: {
    async getDeptTree() {
      let res = await requestGetSysDeptTree();
      if ((res.status = 200)) {
        console.log(res);
        this.sysdeptData = res.data;
        this.qparam.deptId = res.data[0].id;
        this.getAllSysUser();
      } else {
        this.$message.error("获取机构树失败");
      }
    },
    handleSizeChange(size) {
      this.qparam.pageNum = 1;
      this.qparam.pageSize = size;
      this.getAllSysUser();
    },
    handleCurrentChange(num) {
      this.qparam.pageNum = num;
      this.getAllSysUser();
    },
    async getAllSysUser() {
      const response = await requestGetAllSysUserTableList(this.qparam);
      if (response.status == 200) {
        this.total = response.data.total;
        this.userData = response.data.rows;
      } else {
        this.$message.error(response.message);
      }
    },
    resetQparam() {
      this.qparam = {
        realName: "",
        phone: "",
        deptId: 0,
      };
      this.getAllSysUser();
    },
    selectUser(userId, userInfo) {
      this.$emit("selectUser", userId);
      this.$emit("selectUserInfo", userInfo);
    },
    nodeClick(data) {
      this.qparam.deptId = data.id;
      this.qparam.pageNum = 1;
      this.getAllSysUser();
    },
  },
  created() {
    this.getDeptTree();
  },
};
</script>

<style scoped></style>
